import { render, staticRenderFns } from "./SessionManagement.vue?vue&type=template&id=e644ec14&scoped=true&"
import script from "./SessionManagement.vue?vue&type=script&lang=ts&"
export * from "./SessionManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e644ec14",
  null
  
)

export default component.exports